<p-toast></p-toast>
<p-dialog [(visible)]="visible" [modal]="true" [closable]="!loading" [dismissableMask]="!loading"
    [style]="{width: '600px', 'max-width': '95vw'}" (onHide)="onClose()"
    [contentStyle]="{'padding':'0', 'border-radius': '16px'}" [style]="{'padding': '0', 'border': 'none'}"
    [showHeader]="false">
    
    <!-- Portfolio Selection via Dropdown -->
    <div *ngIf="showPortfolioDropdown" class="selection-section">
        <div class="selection-header">
            <h2 class="selection-title">Select Portfolio</h2>
            <p class="selection-subtitle">Choose your investment opportunity</p>
        </div>

        <div class="portfolio-select">
            <p-select
                [options]="allPortfolios"
                optionLabel="name"
                placeholder="Select a portfolio"              
                [style]="{width:'fit-content'}"
                [(ngModel)]="portfolio"
                appendTo="body"
                (onChange)="onPortfolioSelect($event.value)">
                <!-- <ng-template pTemplate="selectedItem" let-value>
                    <div class="dropdown-item" *ngIf="value">
                        <span class="name">{{ value?.name }}</span>
                        <span class="meta">• {{ formatCurrency(value?.ticketPrice) }} • {{ value?.roiPotential }}% ROI</span>
                    </div>
                </ng-template> -->
                <!-- <ng-template let-opt pTemplate="item">
                    <div class="dropdown-item">
                        <span class="name">{{ opt?.name }}</span>
                        <span class="meta">{{ formatCurrency(opt?.ticketPrice) }} • {{ opt?.roiPotential }}% ROI</span>
                    </div>
                </ng-template> -->
            </p-select>
        </div>
    </div>
    <ng-container *ngIf="portfolio">
        <div class="investment-dialog">
            <!-- Loading Overlay -->
            <div *ngIf="loading" class="loading-overlay">
                <p-progressSpinner styleClass="w-8 h-8" strokeWidth="4"></p-progressSpinner>
                <span class="loading-text">Processing...</span>
            </div>

            <!-- Dialog Header -->
            <div class="dialog-header">
                <div class="header-main">
                    <h2 class="portfolio-title">{{ portfolio?.name }}</h2>
                    <div class="roi-badge">{{ portfolio?.roiPotential }}% ROI</div>
                </div>
                <p class="portfolio-desc">{{ portfolio?.description }}</p>
            </div>

            <!-- Investment Details -->
            <div class="investment-details">
                <!-- Key Metrics Row -->
                <div class="metrics-row">
                    <div class="metric">
                        <!-- <i-lucide name="euro" class="metric-icon"></i-lucide> -->
                        <img src="/assets/images/icons/UAE_Dirham_Symbol.svg" class="metric-icon AED-curreny-symbol " alt="AED Currency Symbol">

                        <div class="metric-content">
                            <span class="metric-label">Ticket Price</span>
                            <span class="metric-value">{{ formatCurrency(portfolio?.ticketPrice) }}</span>
                        </div>
                    </div>
                    
                    <div class="metric">
                        <i-lucide name="clock" class="metric-icon"></i-lucide>
                        <div class="metric-content">
                            <span class="metric-label">Duration</span>
                            <span class="metric-value">{{ formatMonthsToYears(portfolio?.tenure) }}</span>
                        </div>
                    </div>
                    
                    <div class="metric">
                        <i-lucide name="shield" class="metric-icon risk-{{ portfolio?.riskLevel?.toLowerCase() }}"></i-lucide>
                        <div class="metric-content">
                            <span class="metric-label">Risk Level</span>
                            <span class="metric-value">{{ portfolio?.riskLevel }}</span>
                        </div>
                    </div>
                </div>
                
                <!-- Ticket Stats Grid -->
                <div class="stats-grid">
                    <div class="stat-card">
                        <span class="stat-number">{{ portfolio?.availableTickets | number }}</span>
                        <span class="stat-label">Available</span>
                    </div>
                    <div class="stat-card">
                        <span class="stat-number">{{ portfolio?.soldTickets | number }}</span>
                        <span class="stat-label">Sold</span>
                    </div>
                    <div class="stat-card">
                        <span class="stat-number">{{ portfolio?.reservedTickets | number }}</span>
                        <span class="stat-label">Reserved</span>
                    </div>
                    <div class="stat-card">
                        <span class="stat-number">{{ portfolio?.totalTickets | number }}</span>
                        <span class="stat-label">Total</span>
                    </div>
                </div>
                
                <!-- Timeline -->
                <div class="timeline-row">
                    <div class="timeline-item">
                        <i-lucide name="calendar" class="timeline-icon"></i-lucide>
                        <div class="timeline-content">
                            <span class="timeline-label">Issue Date</span>
                            <span class="timeline-date">{{ portfolio?.investmentStartDate | date:'MMM d, yyyy' }}</span>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <i-lucide name="calendar-x" class="timeline-icon"></i-lucide>
                        <div class="timeline-content">
                            <span class="timeline-label">Closure Date</span>
                            <span class="timeline-date">{{ portfolio?.investmentClosureDate | date:'MMM d, yyyy' }}</span>
                        </div>
                    </div>
                </div>
                
                <!-- Focus Tags -->
                <div class="focus-section" *ngIf="portfolio?.investmentFocus?.length">
                    <div class="focus-tags">
                        <span *ngFor="let focus of portfolio?.investmentFocus" class="focus-tag">
                            {{ focus }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Ticket Selection -->
            <div class="ticket-section">
                <div class="section-header">
                    <h3 class="section-title">Number of Tickets</h3>
                    <span class="price-info">{{ formatCurrency(portfolio?.ticketPrice) }} per ticket</span>
                </div>

                <div class="ticket-counter">
                    <button type="button" class="counter-btn" (click)="onTicketCountChange(ticketCount - 1)"
                        [disabled]="ticketCount <= 1 || loading">
                        <i-lucide name="minus" class="h-4 w-4"></i-lucide>
                    </button>
                    <span class="counter-value">{{ ticketCount }}</span>
                    <button type="button" class="counter-btn" (click)="onTicketCountChange(ticketCount + 1)"
                        [disabled]="ticketCount >= portfolio?.availableTickets || loading">
                        <i-lucide name="plus" class="h-4 w-4"></i-lucide>
                    </button>
                </div>
            </div>

            <!-- Total Investment -->
            <div class="total-section">
                <div class="total-content">
                    <span class="total-label">Total Investment</span>
                    <span class="total-amount">{{ formatCurrency(totalAmount) }}</span>
                </div>
            </div>

            <!-- Warning Message -->
            <div class="warning-section" *ngIf="warning">
                <div class="warning-message">
                    <i-lucide name="alert-triangle" class="h-4 w-4"></i-lucide>
                    <span>{{ warning }}</span>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="action-buttons">
                <button type="button" class="btn btn-secondary" (click)="onClose()" [disabled]="loading">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" (click)="onBuy()" [disabled]="isInvestDisabled">
                    <span>{{ loading ? 'Processing...' : 'Invest Now' }}</span>
                    <i-lucide name="arrow-right" class="h-4 w-4" *ngIf="!loading"></i-lucide>
                </button>
            </div>
        </div>
    </ng-container>
</p-dialog>